import { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fr } from 'date-fns/locale';
import { theme } from '@/theme';
import { AppHeader } from '@/components/AppHeader';
import { MessageForm } from '@/components/MessageForm';
import { ZohoLogin } from '@/components/ZohoLogin';
import { PortalSelector } from '@/components/PortalSelector';
import { useAppStore } from '@/store/useAppStore';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useState } from 'react';

function App() {
  const { auth, selectedPortal, setSelectedPortal } = useAppStore();
  const [portalSelectorKey, setPortalSelectorKey] = useState(0);

  // Réinitialiser l'état quand l'authentification change
  useEffect(() => {
    if (!auth) {
      setSelectedPortal(null);
      setPortalSelectorKey(prev => prev + 1);
    }
  }, [auth, setSelectedPortal]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
        <CssBaseline />
        <ErrorBoundary>
          <Box
            sx={{
              minHeight: '100vh',
              backgroundColor: 'background.default',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <AppHeader />
            <Box
              component="main"
              sx={{
                flex: 1,
                py: 4,
                px: { xs: 2, sm: 4, md: 6 },
                maxWidth: '1400px',
                mx: 'auto',
                width: '100%',
              }}
            >
              {!auth ? (
                <ZohoLogin />
              ) : (
                <>
                  <PortalSelector 
                    key={portalSelectorKey}
                    onPortalSelect={(portal) => {
                      setSelectedPortal(portal);
                    }} 
                  />
                  {selectedPortal && (
                    <>
                      <MessageForm selectedPortal={selectedPortal} />
                    </>
                  )}
                </>
              )}
            </Box>
          </Box>
        </ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App; 